export default __webpack_public_path__ + "3a19c486f84e6e2d98016a604ede8218.png";